module.exports = __webpack_public_path__ + "img/fang.05c66c1e.png";